module.exports = __webpack_public_path__ + "img/institut-douglas.98124446.png";